import React from 'react'
import ButtonBasic from "./ButtonBasic";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';

const ButtonDelete = ({ label, ariaLabel, cypressid, style: userStyles = {}, ...props }) => {

    return (
        <ButtonBasic
            label={label}
            ariaLabel={ariaLabel}
            style={userStyles}
            id="danger"
            cypressid={cypressid}
            {...props}
        ><FontAwesomeIcon className="font-icon" icon={faTrashAlt} aria-hidden="true" /></ButtonBasic>
    )
}

ButtonDelete.defaultProps = {
    label: "Delete",
    cypressid: "delete"
}

export default ButtonDelete;